<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <b-alert
      variant="success"
      :show="messageObject.success.count"
      dismissible
      @dismissed="messageObject.success.count = 0"
      @dismiss-count-down="successCountChanged"
      >{{ messageObject.success.content }}
    </b-alert>
    <!-- <b-alert variant="warning" show>等待資訊</b-alert> -->
    <div class="Info_Area">
      <b-container fluid>
        <b-row>
          <b-col>
            <b-row>
              <b-col>
                <b-button
                  v-show="showmanage.add"
                  @click="$router.push({ path: '/databuildadd/add' })"
                  variant="warning"
                  >新增價格</b-button
                >
              </b-col>
              <b-col cols="auto">
                <!-- <label style="margin-right: 0.5rem;">
                  <label for="file" class="btn btn-success">匯入</label>
                  <input
                    @change="uploadFile"
                    id="file"
                    type="file"
                    style="display: none;"
                  />
                </label> -->
                <export-excel
                  :data="exceldata.dataset"
                  :fields="exceldata.fields"
                  :worksheet="exceldata.filename"
                  :name="exceldata.filename + getNow()"
                >
                  <b-button style="padding-right: 10px;" variant="warning"
                    >匯出</b-button
                  >
                </export-excel>
              </b-col>
            </b-row>
            <b-row>
              <div class="container-fluid">
                <div class="index-top-info">
                  <b-form inline>
                    <b-input-group>
                      <label class="sr-only"
                        >Name</label
                      >
                      <b-input-group-text>
                        <b-icon icon="calendar3"></b-icon>
                      </b-input-group-text>
                      <datepicker
                        v-model="timepicker.minvalue"
                        min="1960-01-01"
                        :max="twtimeparse(timepicker.maxvalue)"
                      ></datepicker>
                    </b-input-group>
                    <span>~</span>
                    <b-input-group style="margin-right: 0.5rem;">
                      <label class="sr-only" 
                        >Name</label
                      >
                      <b-input-group-text is-text>
                        <b-icon icon="calendar3"></b-icon>
                      </b-input-group-text>
                      <datepicker
                        v-model="timepicker.maxvalue"
                        :min="twtimeparse(timepicker.minvalue)"
                        :max="timepicker.max"
                      ></datepicker>
                    </b-input-group>
                    <v-select
                      style="min-width: 8rem;margin-right: 0.5rem;"
                      v-model="fruit.value"
                      :options="fruit.options"
                    ></v-select>
                    <b-button @click="filteritems" variant="warning"
                      >查詢</b-button
                    >
                  </b-form>
                </div>
              </div>
            </b-row>
            <b-row>
              <b-col>*批發交易行情取最近一日之台北一交易資料</b-col>
            </b-row>
          </b-col>
        </b-row>
        <template v-if="showmanage.maintain">
          <b-row>
            <b-col cols="auto">
              <b-table
                :items="priceanalysis.items"
                :fields="
                  window.width < 650
                    ? priceanalysis.fields_mobile
                    : window.width < 1000
                    ? priceanalysis.fields_laptop
                    : priceanalysis.fields
                "
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                responsive
                striped
                bordered
                outlined
                hover
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template #thead-top head-variant="dark">
                  <b-tr class="thead-dark">
                    <b-th rowspan="2">日期</b-th>
                    <b-th rowspan="2">品項</b-th>
                    <!-- <b-th rowspan="2">規格</b-th> -->
                    <template v-if="window.width >= 650">
                      <b-th colspan="3">批發交易行情 (元/公斤)</b-th>
                      <b-th colspan="3">嘉義縣產地價 (元/公斤)</b-th>
                    </template>
                    <template v-if="window.width >= 1000">
                      <b-th rowspan="2">農糧署產地價格監控 (元/公斤)</b-th>
                      <b-th rowspan="2">詢問單位</b-th>
                      <b-th rowspan="2">備註及說明</b-th>
                    </template>
                    <b-th v-show="showmanage.edit" rowspan="2">操作</b-th>
                  </b-tr>
                  <b-tr v-if="window.width >= 650" class="thead-dark">
                    <b-th>上價</b-th>
                    <b-th>中價</b-th>
                    <b-th>下價</b-th>
                    <b-th>上價</b-th>
                    <b-th>中價</b-th>
                    <b-th>下價</b-th>
                  </b-tr>
                </template>
                <template #cell(CROP_NAME)="data">
                  <div>
                    {{ data.item.CROP_NAME }}
                  </div>
                </template>
                <template #cell(EDIT)="data">
                  <b-button
                    v-if="window.width < 1000"
                    variant="success"
                    style="margin-bottom: 0.3rem;"
                    @click="data.toggleDetails"
                  >
                    {{ data.detailsShowing ? "隱藏" : "詳細" }}
                  </b-button>
                  <b-button
                    v-show="showmanage.edit"
                    @click="changePage(data)"
                    variant="warning"
                    >編輯</b-button
                  >
                </template>
                <template #row-details="row">
                  <b-card>
                    <template v-if="window.width < 650">
                      <b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"
                          ><b>批發交易行情上價:</b></b-col
                        >
                        <b-col>{{ row.item.PRICE_C }}</b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"
                          ><b>批發交易行情中價:</b></b-col
                        >
                        <b-col>{{ row.item.PRICE_M }}</b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"
                          ><b>批發交易行情下價:</b></b-col
                        >
                        <b-col>{{ row.item.PRICE_F }}</b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"
                          ><b>嘉義縣產地價上價:</b></b-col
                        >
                        <b-col>{{ row.item.CM_PRICE_C }}</b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"
                          ><b>嘉義縣產地價中價:</b></b-col
                        >
                        <b-col>{{ row.item.CM_PRICE_M }}</b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"
                          ><b>嘉義縣產地價下價:</b></b-col
                        >
                        <b-col>{{ row.item.CM_PRICE_F }}</b-col>
                      </b-row>
                    </template>
                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"
                        ><b>農糧署產地價格監控:</b></b-col
                      >
                      <b-col>{{ row.item.CM_PRICE_MON }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"><b>詢問單位:</b></b-col>
                      <b-col>{{ row.item.CM_QUEST }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"
                        ><b>備註及說明:</b></b-col
                      >
                      <b-col>{{ row.item.CM_NOTES }}</b-col>
                    </b-row>
                    <b-button variant="success" @click="row.toggleDetails"
                      >隱藏</b-button
                    >
                  </b-card>
                </template>
              </b-table>
              <b-pagination
                v-show="totalRows > perPage"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="companyList"
                align="center"
              >
              </b-pagination>
            </b-col>
          </b-row>
        </template>
        <template v-else>
          <b-row>
            <b-col cols="auto">
              <b-table
                :items="priceanalysis.items"
                :fields="
                  window.width < 650
                    ? priceanalysis_withMon.fields_mobile
                    : window.width < 1000
                    ? priceanalysis_withMon.fields_laptop
                    : priceanalysis_withMon.fields
                "
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                responsive
                striped
                bordered
                outlined
                hover
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template #thead-top head-variant="dark">
                  <b-tr class="thead-dark">
                    <b-th rowspan="2">日期</b-th>
                    <b-th rowspan="2">品項</b-th>
                    <!-- <b-th rowspan="2">規格</b-th> -->
                    <template v-if="window.width >= 650">
                      <b-th colspan="3">批發交易行情 (元/公斤)</b-th>
                      <b-th colspan="3">嘉義縣產地價 (元/公斤)</b-th>
                    </template>
                    <template v-if="window.width >= 1000">
                      <b-th rowspan="2">詢問單位</b-th>
                      <b-th rowspan="2">備註及說明</b-th>
                    </template>
                    <b-th v-show="showmanage.edit" rowspan="2">操作</b-th>
                  </b-tr>
                  <b-tr v-if="window.width >= 650" class="thead-dark">
                    <b-th>上價</b-th>
                    <b-th>中價</b-th>
                    <b-th>下價</b-th>
                    <b-th>上價</b-th>
                    <b-th>中價</b-th>
                    <b-th>下價</b-th>
                  </b-tr>
                </template>
                <template #cell(CROP_NAME)="data">
                  <div>
                    {{ data.item.CROP_NAME }}
                  </div>
                </template>
                <template #cell(EDIT)="data">
                  <b-button
                    v-if="window.width < 1000"
                    variant="success"
                    style="margin-bottom: 0.3rem;"
                    @click="data.toggleDetails"
                  >
                    {{ data.detailsShowing ? "隱藏" : "詳細" }}
                  </b-button>
                  <b-button
                    v-show="showmanage.edit"
                    @click="changePage(data)"
                    variant="warning"
                    >編輯</b-button
                  >
                </template>
                <template #row-details="row">
                  <b-card>
                    <template v-if="window.width < 650">
                      <b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"
                          ><b>批發交易行情上價:</b></b-col
                        >
                        <b-col>{{ row.item.PRICE_C }}</b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"
                          ><b>批發交易行情中價:</b></b-col
                        >
                        <b-col>{{ row.item.PRICE_M }}</b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"
                          ><b>批發交易行情下價:</b></b-col
                        >
                        <b-col>{{ row.item.PRICE_F }}</b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"
                          ><b>嘉義縣產地價上價:</b></b-col
                        >
                        <b-col>{{ row.item.CM_PRICE_C }}</b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"
                          ><b>嘉義縣產地價中價:</b></b-col
                        >
                        <b-col>{{ row.item.CM_PRICE_M }}</b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"
                          ><b>嘉義縣產地價下價:</b></b-col
                        >
                        <b-col>{{ row.item.CM_PRICE_F }}</b-col>
                      </b-row>
                    </template>
                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"><b>詢問單位:</b></b-col>
                      <b-col>{{ row.item.CM_QUEST }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"
                        ><b>備註及說明:</b></b-col
                      >
                      <b-col>{{ row.item.CM_NOTES }}</b-col>
                    </b-row>
                    <b-button variant="success" @click="row.toggleDetails"
                      >隱藏</b-button
                    >
                  </b-card>
                </template>
              </b-table>
              <b-pagination
                v-show="totalRows > perPage"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="companyList"
                align="center"
              >
              </b-pagination>
            </b-col>
          </b-row>
        </template>
      </b-container>
    </div>
  </b-container>
</template>
<script>
import CROPCODELIST from "@/data/CROP_CODE_LIST.json";
import datepicker from "@/components/Datepicker.vue";

export default {
  data() {
    var date = new Date();
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    const minDate = new Date(today);
    minDate.setDate(date.getDate() - 7);
    var taiwanMinDate = minDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMinDate[0] = parseInt(taiwanMinDate[0]) - 1911;
    taiwanMinDate[1] =
      taiwanMinDate[1].length == 1 ? 0 + taiwanMinDate[1] : taiwanMinDate[1];
    taiwanMinDate[2] =
      taiwanMinDate[2].length == 1 ? 0 + taiwanMinDate[2] : taiwanMinDate[2];
    var taiwanMaxDate = maxDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
      taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    taiwanMaxDate[2] =
      taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
      perPage: 10,
      currentPage: 1,
      filterSearch: null,
      sortBy: "CM_DATE",
      selection: [],
      totalRows: 1,
      cropcodelist: CROPCODELIST,
      isBusy: true,
      timepicker: {
        minvalue: taiwanMinDate.join("-"),
        maxvalue: taiwanMaxDate.join("-"),
        max: maxDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
      },
      filtervalue: null,
      datamanagement: {
        ifshow: false,
        ifedit: false,
      },
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "資料管理",
          active: true,
        },
        {
          text: "農產品價格維護",
          active: true,
        },
      ],
      exceldata: {
        fields: {
          日期: "CM_DATE",
          品項: "CROP_NAME",
          // 規格:"CROP_SPEC",
          批發交易行情上價: "PRICE_C",
          批發交易行情中價: "PRICE_M",
          批發交易行情下價: "PRICE_F",
          嘉義縣產地價上價: "CM_PRICE_C",
          嘉義縣產地價中價: "CM_PRICE_M",
          嘉義縣產地價下價: "CM_PRICE_F",
          農糧署產地價格監控: "CM_PRICE_MON",
          詢問單位: "CM_QUEST",
          備註及說明: "CM_NOTES",
        },
        dataset: [],
        filename: "農產品價格清單",
      },
      priceanalysis: {
        fields: [
          {
            key: "CM_DATE",
            label: "日期",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CROP_NAME",
            label: "品項",
            thClass: "hideheadr",
            visible: true,
          },
          // {
          //   key: "CROP_SPEC",
          //   label: "規格",
          //   thClass: "hideheadr",
          //   visible: true,
          // },
          {
            key: "PRICE_C",
            label: "上價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "PRICE_M",
            label: "中價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "PRICE_F",
            label: "下價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_C",
            label: "上價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_M",
            label: "中價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_F",
            label: "下價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_MON",
            label: "農糧署產地價格監控 (元/公斤)",
            thClass: "hideheadr",
            visible: false,
          },
          {
            key: "CM_QUEST",
            label: "詢問單位",
            thClass: "hideheadr",
            visible: false,
          },
          {
            key: "CM_NOTES",
            label: "備註及說明",
            thClass: "hideheadr",
            visible: false,
          },
          {
            key: "EDIT",
            label: "操作",
            thClass: "hideheadr",
            visible: true,
          },
        ],
        fields_laptop: [
          {
            key: "CM_DATE",
            label: "日期",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CROP_NAME",
            label: "品項",
            thClass: "hideheadr",
            visible: true,
          },
          // {
          //   key: "CROP_SPEC",
          //   label: "規格",
          //   thClass: "hideheadr",
          //   visible: true,
          // },
          {
            key: "PRICE_C",
            label: "上價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "PRICE_M",
            label: "中價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "PRICE_F",
            label: "下價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_C",
            label: "上價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_M",
            label: "中價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_F",
            label: "下價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "EDIT",
            label: "操作",
            thClass: "hideheadr",
            visible: true,
          },
        ],
        fields_mobile: [
          {
            key: "CM_DATE",
            label: "日期",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CROP_NAME",
            label: "品項",
            thClass: "hideheadr",
            visible: true,
          },
          // {
          //   key: "CROP_SPEC",
          //   label: "規格",
          //   thClass: "hideheadr",
          //   visible: true,
          // },
          {
            key: "EDIT",
            label: "操作",
            thClass: "hideheadr",
            visible: true,
          },
        ],
        items: [],
        allitems: [],
        additem: {},
      },
      priceanalysis_withMon: {
        fields: [
          {
            key: "CM_DATE",
            label: "日期",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CROP_NAME",
            label: "品項",
            thClass: "hideheadr",
            visible: true,
          },
          // {
          //   key: "CROP_SPEC",
          //   label: "規格",
          //   thClass: "hideheadr",
          //   visible: true,
          // },
          {
            key: "PRICE_C",
            label: "上價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "PRICE_M",
            label: "中價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "PRICE_F",
            label: "下價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_C",
            label: "上價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_M",
            label: "中價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_F",
            label: "下價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_QUEST",
            label: "詢問單位",
            thClass: "hideheadr",
            visible: false,
          },
          {
            key: "CM_NOTES",
            label: "備註及說明",
            thClass: "hideheadr",
            visible: false,
          },
          {
            key: "EDIT",
            label: "操作",
            thClass: "hideheadr",
            visible: true,
          },
        ],
        fields_laptop: [
          {
            key: "CM_DATE",
            label: "日期",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CROP_NAME",
            label: "品項",
            thClass: "hideheadr",
            visible: true,
          },
          // {
          //   key: "CROP_SPEC",
          //   label: "規格",
          //   thClass: "hideheadr",
          //   visible: true,
          // },
          {
            key: "PRICE_C",
            label: "上價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "PRICE_M",
            label: "中價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "PRICE_F",
            label: "下價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_C",
            label: "上價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_M",
            label: "中價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_F",
            label: "下價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "EDIT",
            label: "操作",
            thClass: "hideheadr",
            visible: true,
          },
        ],
        fields_mobile: [
          {
            key: "CM_DATE",
            label: "日期",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CROP_NAME",
            label: "品項",
            thClass: "hideheadr",
            visible: true,
          },
          // {
          //   key: "CROP_SPEC",
          //   label: "規格",
          //   thClass: "hideheadr",
          //   visible: true,
          // },
          {
            key: "EDIT",
            label: "操作",
            thClass: "hideheadr",
            visible: true,
          },
        ],
        items: [],
        allitems: [],
        additem: {},
      },
      window: {
        width: 1024,
        height: 0,
      },
      messageObject: {
        warning: {
          content: null,
          count: 0,
        },
        success: {
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      showmanage: {
        maintain: false,
        show: false,
        add: false,
        edit: false,
        delete: false,
        count: 0,
      },
      fruit: {
        options: [
          { label: "全部", code: "全部" },
          { label: "香蕉", code: "001" },
          { label: "鳳梨 金鑽鳳梨", code: "002" },
          { label: "木瓜 網室紅肉", code: "003" },
        ],
        fruitoptions: [
          { text: "", value: "001" },
          { text: "金鑽鳳梨", value: "002" },
          { text: "網室紅肉", value: "003" },
        ],
        value: { label: "全部", code: "全部" },
      },
      apiGetTradeWarningCrop: (data) =>
        this.userRequest.post("/API/Default/getTradeWarningCrop", data),
      apiUpdateTradeWarningCrop: (data) =>
        this.userRequest.post("/API/Default/updateTradeWarningCrop", data),
      apiCropManagementList: (data) =>
        this.userRequest.post("/API/Default/CropManagementList", data),
      apiRiceFarmExcelUpload: (data) =>
        this.userRequest.post("/API/Default/RiceFarmExcelUpload", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }),
    };
  },
  created() {
    this.checkLogin();
    // window.addEventListener("resize", this.handleResize);
    // this.handleResize();
    // this.init();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    // this.checkPermission()
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      this.showmanage.count = 0;
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000006",
        fun: this.checkByPJIDshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000007",
        fun: this.checkByPJIDadd,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000008",
        fun: this.checkByPJIDedit,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000030",
        fun: this.checkByPJIMaintain,
      });
      // this.FunctionToken(this.Authority, {
      //   PJ_ID: "PJ000000000009",
      //   fun: this.checkByPJIDdelete,
      // });
    },
    // checkByPJID(value) {
    //   if (!value) {
    //     alert("無權限檢視此頁面，將返回首頁");
    //     this.$router.push({ path: "/" });
    //   } else {
    //     window.addEventListener("resize", this.handleResize);
    //     this.handleResize();
    //     this.init();
    //   }
    // },
    checkallpermission() {
      if (this.showmanage.show || this.showmanage.add || this.showmanage.edit) {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        this.init();
      } else {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      }
    },
    checkByPJIDshow(value) {
      this.showmanage.count++;
      if (value) this.showmanage.show = true;
    },
    checkByPJIDadd(value) {
      this.showmanage.count++;
      if (value) this.showmanage.add = true;
    },
    checkByPJIDedit(value) {
      this.showmanage.count++;
      if (value) this.showmanage.edit = true;
    },
    checkByPJIMaintain(value) {
      if (value) this.showmanage.maintain = true;
    },
    checkByPJIDdelete(value) {
      this.showmanage.count++;
      if (value) this.showmanage.delete = true;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    init() {
      this.createoptions();
      this.getCropManagementList();
      // this.settotalRows();
      // this.priceanalysis.items = [...this.priceanalysis.allitems]
    },
    getName(code) {
      let index = this.cropcodelist.findIndex((y) => y.CROP_CODE == code);
      return this.cropcodelist[index].CROP;
    },
    createoptions() {
      let list2 = [{ label: "全部", code: "全部" }];
      for (let i in this.cropcodelist) {
        let item1 = this.cropcodelist[i];
        let obj = {
          label: item1.CROP,
          code: item1.CROP_CODE,
        };
        list2.push(obj);
      }
      this.fruit.options = list2;
    },
    // checkdate(event)
    // {
    //   event.activeFormatted = "110年8月18日 星期三"
    //   event.activeYMD = "110-08-18"
    //   event.selectedFormatted = "110年8月18日 星期三"
    //   event.selectedYMD = "110-08-18"
    // },
    filteritems() {
      if (this.fruit.value == undefined || this.fruit.value == null) {
        alert("請選擇搜尋條件");
      } else {
        let localmintime = this.timepicker.minvalue.split("-");
        localmintime[0] = parseInt(localmintime[0]) + 1911;
        let localmaxtime = this.timepicker.maxvalue.split("-");
        localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;
        let obj = {
          start_date: localmintime.join("-"),
          end_date: localmaxtime.join("-"),
        };
        if (this.fruit.value.code != "全部") {
          obj["crop_code"] = this.fruit.value.code;
        }
        this.isBusy = true;
        this.FunctionToken(this.cropManagementList, obj);
      }
    },
    // async checkPermission() {
    //   let accountdata = { PJ_ID: "PJ000000000014", fun: this.checkshowByPJID };
    //   this.FunctionToken(this.Authority, accountdata);
    //   let databuilddata = {
    //     PJ_ID: "PJ000000000015",
    //     fun: this.checkeditdataByPJID,
    //   };
    //   this.FunctionToken(this.Authority, databuilddata);
    // },
    // checkshowByPJID(value) {
    //   if (!value) {
    //     alert("無權限檢視此頁面，將返回首頁");
    //     this.datamanagement.ifshow = false;
    //     this.$router.push({ path: "/" });
    //   } else {
    //     this.datamanagement.ifshow = true;
    //     this.FunctionToken(this.getTradeWarningCrop, {});
    //     this.settotalRows();
    //   }
    // },
    // checkeditdataByPJID(value) {
    //   if (!value) {
    //     this.datamanagement.ifedit = false;
    //   } else {
    //     this.datamanagement.ifedit = true;
    //   }
    // },
    checksave(item) {
      if (this.IsNull(item.TC_LIMIT)) {
        this.priceanalysis.additem = item;
        this.$bvModal.show("savemodal");
      }
    },
    changePage(item) {
      let value = item.item.CM_DATE.split("-");
      // value[0] = value[0] - 1911
      this.$router.push({
        name: "DataBuildAdd",
        params: { id: value.join("-") },
      });
    },
    hideModal() {
      this.priceanalysis.additem = {};
      this.$bvModal.hide("savemodal");
    },
    getNow: function() {
      const today = new Date();
      const date =
        today.getFullYear() +
        "" +
        (today.getMonth() + 1) +
        "" +
        today.getDate();
      const time =
        today.getHours() + "" + today.getMinutes() + "" + today.getSeconds();
      const dateTime = date + "" + time;
      return "-" + dateTime;
    },
    saveProcess() {
      let obj = {
        TC_ID: this.priceanalysis.additem.TC_ID,
        TC_LIMIT: this.priceanalysis.additem.TC_LIMIT,
      };
      this.FunctionToken(this.updateTradeWarningCrop, obj);
    },
    getCropManagementList() {
      this.isBusy = true;

      let localmintime = this.timepicker.minvalue.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let localmaxtime = this.timepicker.maxvalue.split("-");
      localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

      let obj = {
        start_date: localmintime.join("-"),
        end_date: localmaxtime.join("-"),
      };
      this.FunctionToken(this.cropManagementList, obj);
    },
    cropManagementList(data) {
      this.apiCropManagementList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.priceanalysis.items = [];
            this.exceldata.dataset = [];
            let dataItems = JSON.parse(json.Data);
            console.log("dataItems",dataItems)
            if (dataItems.length != 0) {
              dataItems.sort((a, b) => {
                if (a.CM_DATE == b.CM_DATE) {
                  return (a.CM_SORT > b.CM_SORT) - (a.CM_SORT < b.CM_SORT);
                }
                return (a.CM_DATE < b.CM_DATE) - (a.CM_DATE > b.CM_DATE);
              });
              for (let i in dataItems) {
                let subitem = dataItems[i];
                let datetime1 = subitem.CM_DATE.split("-");
                datetime1[0] = parseInt(datetime1[0]) - 1911;
                subitem.CM_DATE = datetime1.join("-");
                subitem.PRICE_C = this.valueParse(subitem.PRICE_C);
                subitem.PRICE_M = this.valueParse(subitem.PRICE_M);
                subitem.PRICE_F = this.valueParse(subitem.PRICE_F);
                subitem.CM_PRICE_C = this.valueParse(subitem.CM_PRICE_C);
                subitem.CM_PRICE_M = this.valueParse(subitem.CM_PRICE_M);
                subitem.CM_PRICE_F = this.valueParse(subitem.CM_PRICE_F);
                subitem.CM_PRICE_MON = this.valueParse(subitem.CM_PRICE_MON);
                //console.log(subitem.CROP_SPEC)
                subitem.CROP_SPEC = subitem.CROP_SPEC == null ? "" : subitem.CROP_SPEC.substring(1, subitem.CROP_SPEC.length - 1)
                this.exceldata.dataset.push(subitem);
              }
              this.priceanalysis.items = dataItems;
              console.log("this.priceanalysis.items",this.priceanalysis.items)
              // this.exceldata.dataset = dataItems
              this.totalRows = dataItems.length;
            }
            if (this.timepicker.minvalue == this.timepicker.maxvalue)
              this.perPage = this.priceanalysis.items.length;
            else this.perPage = 10;
            this.isBusy = false;
          }
        })
        .catch((err) => console.warn(err));
    },
    updateTradeWarningCrop(data) {
      this.apiUpdateTradeWarningCrop(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.suceessPopUp("儲存成功");
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getTradeWarningCrop(data) {
      this.apiGetTradeWarningCrop(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          let jsonData = JSON.parse(json.Data);
          if (json.Status) {
            this.priceanalysis.items = jsonData;
            this.addcount();
            this.isBusy = false;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    addcount() {
      for (let i in this.priceanalysis.items) {
        this.priceanalysis.items[i]["Count"] = parseInt(i) + 1;
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`)
      // let y = ymd
      const weekday = date.getDay();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6;
    },
    twtimeparse(item) {
      let tt = item.split("-");
      tt[0] = parseInt(tt[0]) + 1911;
      return tt.join("-");
    },
    changetimeformat(time) {
      let tt = time.split("-");
      tt[0] = parseInt(tt[0]) - 1911;
      return tt.join("-");
    },
    settotalRows() {
      this.totalRows = this.priceanalysis.items.length;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    suceessPopUp(msg) {
      this.messageObject.success.count = this.messageObject.dismissSecs;
      this.messageObject.success.content = msg;
    },
    successCountChanged(count) {
      this.messageObject.success.count = count;
    },
    uploadFile(e) {
      const file = e.target.files[0];
      const inputEl = e.target;
      if (!file) return;

      const fileName = file.name || "";
      const fileType = file.type || "";
      const ext = fileName.includes(".")
        ? fileName.split(".").pop().toLowerCase()
        : "";
      const allowedExt = ["xls", "xlsx"];
      const allowedMimeTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];

      if (!allowedExt.includes(ext) && !allowedMimeTypes.includes(fileType)) {
        alert("僅允許上傳 xls、xlsx 檔案");
        inputEl.value = "";
        return;
      }
      // console.log(file);
      let formdata = new FormData();
      formdata.append("Files", file);
      // this.$axios.post('API/Default/Post',formdata)
      this.apiRiceFarmExcelUpload(formdata)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            // let jsonData = JSON.parse(json.Data);
            // console.log(jsonData);
            alert("上傳成功");
            this.$route.go();
            //success(jsonData.SP_PATH+jsonData.MC_FILE);
          } else {
            console.warn("上傳失敗");
          }
        });
    },
    valueParse(data) {
      // console.log(data);
      if (data == 0) return "-";
      return data;
    },
  },
  computed: {
    visibleFields() {
      return this.priceanalysis.fields.filter((field) => field.visible);
    },
  },
  watch: {
    "priceanalysis.items"() {
      this.settotalRows();
    },
    "showmanage.count"(val) {
      if (val == 3) {
        this.checkallpermission();
      }
    },
    // "exceldata.dataset" (val) {
    //   //console.log(val)
    // }
  },
  components: {
    datepicker,
  },
};
</script>

<style scoped>
.table thead th {
  vertical-align: middle !important;
}
.hideheadr {
  background-color: red !important;
}
.date-panel {
  left: -5rem;
}
</style>
